import { render, staticRenderFns } from "./validate-order-confirmation.vue?vue&type=template&id=277a28b8&"
import script from "./validate-order-confirmation.vue?vue&type=script&lang=js&"
export * from "./validate-order-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports